import { render } from "./ServiceOverviewSection.vue?vue&type=template&id=25d86d43&scoped=true"
import script from "./ServiceOverviewSection.vue?vue&type=script&lang=js"
export * from "./ServiceOverviewSection.vue?vue&type=script&lang=js"

import "./ServiceOverviewSection.vue?vue&type=style&index=0&id=25d86d43&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d86d43"]])

export default __exports__